var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIndeterminate = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 10 10",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M2.465 7.95 4.95 5.467 7.435 7.95l.515-.515L5.467 4.95 7.95 2.465l-.515-.515L4.95 4.433 2.465 1.95l-.515.515L4.433 4.95 1.95 7.435z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIndeterminate);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/indeterminate.63cd50722a9eafac6feab42123cfa64a.svg";